import { DisposableCollection } from '../../misc/DisposableCollection/DisposableCollection';
import { Disposable } from '../../utils/DisposableContainer/DisposableContainer';
export class EventDispatcher<TEventConfig> {
  private eventListenerCollection = new DisposableCollection<IEventListener<TEventConfig>>();
  public addEventListener<T extends keyof TEventConfig>(eventName: T, callback: (payload: TEventConfig[T]) => void): Disposable {
    const eventListener: IEventListener<TEventConfig, T> = {
      eventName,
      callback
    };
    return this.eventListenerCollection.add(eventListener);
  }
  public dispatchEvent<T extends keyof TEventConfig>(eventName: T, payload: TEventConfig[T]): void {
    for (const listener of this.eventListenerCollection.toArray()) {
      if (listener.eventName === eventName) {
        listener.callback(payload);
      }
    }
  }
}
interface IEventListener<TEventConfig, TKey extends keyof TEventConfig = any> {
  eventName: TKey;
  callback: (payload: TEventConfig[TKey]) => void;
}